import { useEffect, useState } from "react";
import { Typography } from "@mui/material";

const CountLikeAndDislike = ({ count = 0, sx = { color: "inherit", fontSize: "13px" } }) => {
    const [formatCount, setFormatCount] = useState(0);

    useEffect(() => {
        if (count < 1000) {
            setFormatCount(count);
        } else if (count < 1000000) {
            setFormatCount(Math.floor(parseInt(count) / 1000) + "K");
        } else if (count >= 1000000) {
            setFormatCount(Math.floor(parseInt(count) / 1000000) + "M");
        } else {
            setFormatCount(0);
        }
    }, [count, setFormatCount]);

    return <Typography sx={{ ...sx }}>{formatCount}</Typography>;
};

export default CountLikeAndDislike;
